import Dispatcher from '../dispatcher';
import resolvePromise from '../helper/resolved_promise';
import CatalogConfiguratorAnalytics from '../../_modules/google_analytics/catalog_configurator';
import CatalogConfiguratorStore from '../stores/catalog_configurator_store';
import { ConfiguratorActions } from '../constants/configurator/configurator_actions';

function showAction() {
    CatalogConfiguratorAnalytics.openAction();
    Dispatcher.handleCatalogConfiguratorAction({
        type: ConfiguratorActions.SHOW_ACTION
    });
}

function submitCatalogConfiguratorForm() {
    CatalogConfiguratorAnalytics.submitAction();
}

function showSizeConfiguratorFromLayerAction(isMoto = false) {
    CatalogConfiguratorAnalytics.openFromConfiguratorLayer(isMoto);
    Dispatcher.handleCatalogConfiguratorAction({
        type: ConfiguratorActions.SHOW_ACTION
    });
}

function showExtendedAction(payload) {
    CatalogConfiguratorAnalytics.openAction();
    Dispatcher.handleCatalogConfiguratorAction({
        type: ConfiguratorActions.SHOW_EXTENDED_ACTION,
        payload
    });
}

function hideAction() {
    Dispatcher.handleCatalogConfiguratorAction({
        type: ConfiguratorActions.HIDE_ACTION,
    });

    return resolvePromise();
}

function closeCatalogConfigurator() {
    CatalogConfiguratorAnalytics.closeAction();
    Dispatcher.handleCatalogConfiguratorAction({
        type: ConfiguratorActions.HIDE_ACTION,
    });

    return resolvePromise();
}


function showFirstLayerAction() {
    CatalogConfiguratorAnalytics.goToFirstLayerAction();
    Dispatcher.handleCatalogConfiguratorAction({
        type: ConfiguratorActions.SHOW_FIRST_LAYER,
    });

    return resolvePromise();
}

function showSecondLayerAction() {
    Dispatcher.handleCatalogConfiguratorAction({
        type: ConfiguratorActions.SHOW_SECOND_LAYER,
    });

    return resolvePromise();
}

function showInfoLayerAction() {
    CatalogConfiguratorAnalytics.showInfoAction();
    Dispatcher.handleCatalogConfiguratorAction({
        type: ConfiguratorActions.SHOW_INFO_LAYER,
    });

    return resolvePromise();
}

function hideInfoLayerAction() {
    Dispatcher.handleCatalogConfiguratorAction({
        type: ConfiguratorActions.HIDE_INFO_LAYER,
    });

    return resolvePromise();
}

function showPostcodeInvalidAction() {
    Dispatcher.handleCatalogConfiguratorAction({
        type: ConfiguratorActions.SHOW_INFO_POSTCODE_INVALID,
    });

    return resolvePromise();
}

function hidePostcodeInvalidAction() {
    Dispatcher.handleCatalogConfiguratorAction({
        type: ConfiguratorActions.HIDE_POSTCODE_INVALID,
    });

    return resolvePromise();
}

function setWidthAction(width, productType) {
    CatalogConfiguratorAnalytics.setWidthAction(width, productType);
    Dispatcher.handleCatalogConfiguratorAction({
        type: ConfiguratorActions.SET_WIDTH,
        payload: width
    });

    return resolvePromise();
}

function setHeightAction(height, productType) {
    CatalogConfiguratorAnalytics.setHeightAction(height, productType);
    Dispatcher.handleCatalogConfiguratorAction({
        type: ConfiguratorActions.SET_HEIGHT,
        payload: height
    });

    return resolvePromise();
}

function setDiameterAction(diameter, productType) {
    CatalogConfiguratorAnalytics.setDiameterAction(diameter, productType);
    Dispatcher.handleCatalogConfiguratorAction({
        type: ConfiguratorActions.SET_DIAMETER,
        payload: diameter
    });

    return resolvePromise();
}

function setSpeedIndexAction(speed_index, productType) {
    CatalogConfiguratorAnalytics.setSpeedIndexAction(speed_index, productType);
    Dispatcher.handleCatalogConfiguratorAction({
        type: ConfiguratorActions.SET_SPEED_INDEX,
        payload: speed_index
    });

    return resolvePromise();
}

function setLoadIndexAction(payload, productType) {
    CatalogConfiguratorAnalytics.setLoadIndexAction(payload, productType);
    Dispatcher.handleCatalogConfiguratorAction({
        type: ConfiguratorActions.SET_LOAD_INDEX,
        payload
    });

    return resolvePromise();
}

function setPostcodeAction(postcode) {
    Dispatcher.handleCatalogConfiguratorAction({
        type: ConfiguratorActions.SET_POSTCODE,
        payload: postcode
    });

    return resolvePromise();
}

function onCatalogPostcodeInputLeave(postcode, productType) {
    CatalogConfiguratorAnalytics.setPostcodeAction(postcode, productType);
}

function setValuesAction(values) {
    Dispatcher.handleCatalogConfiguratorAction({
        type: ConfiguratorActions.SET_VALUES,
        payload: values
    });

    return resolvePromise();
}

function setBackupValuesAction(values) {
    Dispatcher.handleCatalogConfiguratorAction({
        type: ConfiguratorActions.SET_BACKUP_VALUES,
        payload: values
    });

    return resolvePromise();
}

function setVisibleSectionsAction(sections) {
    Dispatcher.handleCatalogConfiguratorAction({
        type: ConfiguratorActions.SET_VISIBLE_SECTIONS,
        payload: sections
    });

    return resolvePromise();
}

function setOutOfStockLoadingAction(filterName) {
    Dispatcher.handleCatalogConfiguratorAction({
        type: ConfiguratorActions.SET_OUT_OF_STOCK_CHECK_LOADING,
        payload: filterName
    });

    return resolvePromise();
}

function setOutOfStockLoadingDoneAction() {
    Dispatcher.handleCatalogConfiguratorAction({
        type: ConfiguratorActions.SET_OUT_OF_STOCK_CHECK_LOADING_DONE
    });

    return resolvePromise();
}

function setOutOfStockAction(payload, productType) {
    CatalogConfiguratorAnalytics.noProductsFoundAction(JSON.stringify(CatalogConfiguratorStore.getState().values), productType);
    Dispatcher.handleCatalogConfiguratorAction({
        type: ConfiguratorActions.SET_OUT_OF_STOCK,
        payload
    });

    return resolvePromise();
}

function setInStockAction(productType) {
    CatalogConfiguratorAnalytics.productsFoundAfterNoneWereFoundAction(JSON.stringify(CatalogConfiguratorStore.getState().values), productType);
    Dispatcher.handleCatalogConfiguratorAction({
        type: ConfiguratorActions.SET_IN_STOCK
    });

    return resolvePromise();
}

function hideTyreIndexAction() {
    Dispatcher.handleCatalogConfiguratorAction({
        type: ConfiguratorActions.HIDE_TYRE_INDEX
    });

    return resolvePromise();
}

function showTyreIndexAction() {
    Dispatcher.handleCatalogConfiguratorAction({
        type: ConfiguratorActions.SHOW_TYRE_INDEX
    });

    return resolvePromise();
}

function hideTyreIndexLinkAction() {
    Dispatcher.handleCatalogConfiguratorAction({
        type: ConfiguratorActions.HIDE_TYRE_INDEX_LINK
    });

    return resolvePromise();
}

function showTyreIndexLinkAction() {
    Dispatcher.handleCatalogConfiguratorAction({
        type: ConfiguratorActions.SHOW_TYRE_INDEX_LINK
    });

    return resolvePromise();
}

function setConfiguratorType(configuratorType) {
    // CatalogConfiguratorAnalytics.setConfiguratorType(configuratorType);
    Dispatcher.handleCatalogConfiguratorAction({
        type: ConfiguratorActions.SET_CONFIGURATOR_TYPE,
        payload: configuratorType
    });

    return resolvePromise();
}

function setPageOriginType(pageOriginType) {
    // CatalogConfiguratorAnalytics.setConfiguratorType(configuratorType);
    Dispatcher.handleCatalogConfiguratorAction({
        type: ConfiguratorActions.SET_PAGE_ORIGIN_TYPE,
        payload: pageOriginType
    });

    return resolvePromise();
}

function setPostSuggestionCatalogConfigurator(payload) {
    Dispatcher.handleCatalogConfiguratorAction({
        type: ConfiguratorActions.SET_POSTCODE_SUGGESTION,
        payload
    });
}

export {
    showAction,
    showExtendedAction,
    hideAction,
    showFirstLayerAction,
    showSecondLayerAction,
    showInfoLayerAction,
    hideInfoLayerAction,
    showPostcodeInvalidAction,
    hidePostcodeInvalidAction,
    setWidthAction,
    setHeightAction,
    setDiameterAction,
    setSpeedIndexAction,
    setLoadIndexAction,
    setPostcodeAction,
    setValuesAction,
    setBackupValuesAction,
    setVisibleSectionsAction,
    setOutOfStockLoadingAction,
    setOutOfStockLoadingDoneAction,
    setOutOfStockAction,
    setInStockAction,
    hideTyreIndexAction,
    showTyreIndexAction,
    showTyreIndexLinkAction,
    hideTyreIndexLinkAction,
    setConfiguratorType,
    setPageOriginType,
    setPostSuggestionCatalogConfigurator,
    closeCatalogConfigurator,
    showSizeConfiguratorFromLayerAction,
    submitCatalogConfiguratorForm,
    onCatalogPostcodeInputLeave,
};
